import i18n from '@/translations/i18n'
import {z} from 'zod'
import {ReferringSpecialistTitle} from './types'

/*The backend stores serviceUoc in a varchar(100) column*/
export const SERVICE_UOC_MAX_LENGTH = 100

export const CreateUpdateReferringSpecialistValidationSchema = z.object({
    title: z.enum(ReferringSpecialistTitle.options, {
        required_error: i18n.t('errors:required'),
        invalid_type_error: i18n.t('errors:required')
    }),
    firstName: z
        .string({required_error: i18n.t('errors:required'), invalid_type_error: i18n.t('errors:required')})
        .min(1, {message: i18n.t('errors:required')})
        .trim(),
    lastName: z
        .string({required_error: i18n.t('errors:required'), invalid_type_error: i18n.t('errors:required')})
        .min(1, {message: i18n.t('errors:required')})
        .trim(),
    serviceUoc: z
        .string({required_error: i18n.t('errors:required'), invalid_type_error: i18n.t('errors:required')})
        .trim()
        .min(1, {message: i18n.t('errors:required')})
        .max(SERVICE_UOC_MAX_LENGTH, {message: i18n.t('errors:max_characters', {max: SERVICE_UOC_MAX_LENGTH})}),
    email: z
        .string({required_error: i18n.t('errors:required'), invalid_type_error: i18n.t('errors:required')})
        .trim()
        .email({message: i18n.t('errors:email_error')})
})
export type CreateUpdateReferringSpecialistValidationSchemaType = z.infer<
    typeof CreateUpdateReferringSpecialistValidationSchema
>
